import { render } from "./EmployeeSalaryOtherComponent.vue?vue&type=template&id=a452ac94&scoped=true"
import script from "./EmployeeSalaryOtherComponent.vue?vue&type=script&lang=js"
export * from "./EmployeeSalaryOtherComponent.vue?vue&type=script&lang=js"

import "./EmployeeSalaryOtherComponent.vue?vue&type=style&index=0&id=a452ac94&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a452ac94"]])

export default __exports__